import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, QueryList,
	ViewChild, ViewChildren, ElementRef
} from '@angular/core';
import { GroupDto, UserClass, getAccountTypeLabel } from 'UvExplorerServer.Dtos.TS/Auth';
import { Table } from 'primeng/table';
import { Dialog } from 'primeng/dialog';
import { UsersService } from '../..';


export class GroupSelectorEntry {
	public dataKey: string;
	public groupname: string;
	public class: string;
	public type: string;
	public active: string;

	public groupTag: GroupDto;
	public get hasGroupTag(): boolean {
		return !!this.groupTag;
	}

	constructor() {
		this.dataKey = "";

		this.groupname = "";
		this.class = "";
		this.type = "";
		this.active = "";

		this.groupTag = null;
	}
}


@Component({
	selector: 'group-selector',
	templateUrl: './group-selector.component.html',
	styleUrls: ['./group-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupSelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public header: string;

	@Input()
	public visible: boolean;

	@Input()
	public minGroups: number;

	@Input()
	public maxGroups: number;

	@Input()
	public except: string[];

	// "full" or "compact"
	@Input()
	public format: string;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<GroupDto[]>

	@Output()
	public onCancel: EventEmitter<any>;

	@ViewChild('dialog', { static: true })
	public dialog: Dialog;

	@ViewChild('table', { static: true })
	public table: Table;

	@ViewChildren('filter')
	public filters: QueryList<ElementRef<HTMLInputElement>>;

	public cols: any[];
	public entries: GroupSelectorEntry[];
	public filterEntries: any[];

	public selectedGroups: any;

	constructor(private changeDetector: ChangeDetectorRef,
		private usersService: UsersService) {

		this.header = "";
		this.visible = false;
		this.minGroups = 1;
		this.maxGroups = 1;
		this.except = [];
		this.format = "full";
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<GroupDto[]>();
		this.onCancel = new EventEmitter<any>();
		this.cols = [];
		this.entries = [];

		this.clearSelectedGroups();
	}

	public ngOnInit(): void {

	}

	private rebuildColumns(): void {
		let isFormatFull = (this.format === "full");

		this.cols = [];
		this.cols.push({ field: 'groupname', header: 'Groupname', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		if (isFormatFull) {
			this.cols.push({ field: 'class', header: 'Class', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		}
		this.cols.push({ field: 'type', header: 'Type', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		if (isFormatFull) {
			this.cols.push({ field: 'active', header: 'Active', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		this.cols = [];
		this.entries = [];
		this.clearSelectedGroups();

		if (this.visible) {
			this.rebuildColumns();
			this.rebuildEntries();

			if (this.filters) {
				this.filters.forEach((filter: ElementRef<HTMLInputElement>) => {
					filter.nativeElement.value = "";
				});
			}

			this.cols.forEach((col) => {
				this.table.filter("", col.field, col.filterMatchMode)
			});

			setTimeout(() => {
				this.dialog.center();
				setTimeout(() => {
					this.dialog.center();
					setTimeout(() => {
						this.dialog.center();
					}, 400);
				}, 200);
			}, 100);
		}
	}

	public ngOnDestroy(): void {

	}

	public doCustomSort(event): void {
		let comparer = function (a: GroupSelectorEntry, b: GroupSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	private clearSelectedGroups(): void {
		this.selectedGroups = (this.maxGroups == 1 ? undefined : []);
	}

	private rebuildEntries(): void {

		this.entries = [];
		this.clearSelectedGroups();

		if (this.usersService.hasGroups) {
			this.usersService.groupTree.Groups.ForEach((group: GroupDto) => {
				if (group.HasName) {
					if (!this.except || !this.except.find((groupGuid: string) => groupGuid === group.Guid)) {
						let entry = new GroupSelectorEntry();

						entry.dataKey = group.Guid;
						entry.groupTag = group;
						entry.groupname = group.Name;
						entry.class = UserClass[group.UserClass];
						entry.type = getAccountTypeLabel(group.AccountType);
						entry.active = (group.IsActive ? 'Yes' : 'No');

						this.entries.push(entry);
					}
				}
			});
		}

		//this.changeDetector.markForCheck();
		this.changeDetector.detectChanges();
	}

	public isOkEnabled(): boolean {
		if (this.maxGroups == 1) {
			return !!this.selectedGroups;
		}
		else {
			if (this.selectedGroups) {
				let len = this.selectedGroups.length;
				return (this.minGroups <= len && len <= this.maxGroups);
			}
			return false;
		}
	}

	public onOkClicked(): void {
		this.onOk.emit(this.getSelectedGroups());
		this.hide();
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	private getSelectedGroups(): GroupDto[] {
		let result: GroupDto[] = [];
		if (this.selectedGroups) {
			if (Array.isArray(this.selectedGroups)) {
				this.selectedGroups.forEach((entry: GroupSelectorEntry) => {
					result.push(entry.groupTag);
				}, this);
			}
			else {
				let entry = <GroupSelectorEntry>this.selectedGroups;
				result.push(entry.groupTag);
			}
		}
		return result;
	}

	public get totalGroupCount(): number {
		if (this.entries)
			return this.entries.length;
		else
			return 0;
	}

	public get selectedGroupCount(): number {
		if (this.selectedGroups) {
			if (Array.isArray(this.selectedGroups)) {
				return this.selectedGroups.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}
}
